// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconFavorite = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12">
            <path
                fill="currentColor"
                d="M6.18516497,0 C6.40079025,0 6.59766511,0.123046875 6.69141511,0.316874743 L8.29922775,3.62812471 L11.8921969,4.16015625 C12.1031344,4.19062471 12.2765711,4.33828139 12.3445404,4.53984368 C12.4101651,4.74374986 12.3562591,4.96640611 12.2062586,5.11406243 L9.600009,7.69687486 L10.216415,11.3414061 C10.2515712,11.5523436 10.1648529,11.7679689 9.98907165,11.8921874 C9.81563358,12.0164065 9.56485275,12.0328131 9.39610247,11.9320314 L6.18516497,10.2164061 L2.95547775,11.9320314 C2.78672747,12.0328131 2.55704025,12.0164065 2.38125865,11.8921874 C2.20782093,11.7679689 2.12110225,11.5523436 2.1351649,11.3414061 L2.77032129,7.69687486 L0.166649501,5.11406243 C0.0152430936,4.96640611 -0.038428624,4.74374986 0.0281337902,4.53984368 C0.0944619581,4.33828139 0.269540112,4.19062471 0.480243365,4.16015625 L4.07110254,3.62812471 L5.67891483,0.316874743 C5.77500872,0.123023272 5.9695404,0 6.18516497,0 Z M6.18516497,1.85039091 L4.95469622,4.38750029 C4.87266497,4.55390632 4.71329025,4.67109382 4.53047768,4.69921875 L1.75735251,5.10703111 L3.77110247,7.1015625 C3.90000872,7.23046875 3.95860247,7.41562486 3.928134,7.59609389 L3.45469622,10.399219 L5.9203215,9.08203125 C6.0867279,8.99296904 6.28594665,8.99296904 6.45000915,9.08203125 L8.91563372,10.399219 L8.44219665,7.59609389 C8.41172747,7.41562486 8.47266511,7.23046875 8.60157136,7.1015625 L10.6148525,5.10703111 L7.8421965,4.69921875 C7.6570404,4.67109382 7.49766497,4.55390632 7.41797761,4.38750029 L6.18516497,1.85039091 Z"
            />
        </svg>
    );
};

export default React.memo(IconFavorite);
